<template>
  <gj-modal
      v-bind="$attrs"
      v-on="$listeners"
      :visible.sync="modalVisible"
      size="full"
      :contentStyle="{'height': '100%', 'display': 'flex', 'flex-direction': 'column'}"
      :footer="false">
    <template #header> 操作日志 </template>
    <template #content>
      <app-base-main parentTable no-padding :table-shadow="false">
        <template #filter-group>
          <app-filter-group :reset="false" @query="$gjNoticeQuery">
            <gj-creator-select
              width="125px"
              v-model="filter.operatorUserId"
              placeholder="请选择操作人"
            ></gj-creator-select>
            <gj-select-input
              v-model="filter.keyword"
              :width="['85px', '150px']"
              :options="options.keyword">
            </gj-select-input>
            <gj-date-picker
              v-model="filter.date"
              type="daterange"
              tooltip="数据时间"
            ></gj-date-picker>
          </app-filter-group>
        </template>
        <template #table>
          <gj-table
              ref="gjTable"
              adaptParent
              :index="false"
              :loading="loading"
              :data="tableData"
              :columns="columns"
              :pagination="pagination"
              @page-change="$gjNoticeQuery">
              <template v-slot:opObject="{ row }">
                  <div>名称：{{ row.groupName || "-"}}</div>
                  <div>ASIN：{{ row.asin || "-"}}</div>
              </template>
              <template v-slot:content="{ row }">
                <div v-if="row.operatingType == 0">
                  <div v-if="row.operatingObject === '关键词'">
                    国家：{{ row.countryCode }}
                  </div>
                  <div class="tooltip-h">
                    <span v-if="row.operatingObject === '关键词'"> 关键词： </span>
                    <span class="tooltip-content">
                      <gj-tooltip :text-line="1" :content="row.target"> {{ row.target || "-"}} </gj-tooltip>
                    </span>
                  </div>
                </div>
                <div v-else-if="row.operatingType == 1">
                  <div v-if="row.operatingObject === '关键词'">
                    国家：{{ row.countryCode }}
                  </div>
                  <div class="tooltip-h">
                    <span v-if="row.operatingObject === '关键词'"> 关键词： </span>
                    <span class="tooltip-content">
                      <gj-tooltip :text-line="1" :content="`${row.source || '-'} -> ${row.target|| '-'}`"> {{ row.source || "-"}} -> {{ row.target || "-"}}</gj-tooltip>
                    </span>
                  </div>
                </div>
                <div v-else-if="row.operatingType == 2">-</div>
              </template>
          </gj-table>
        </template>
      </app-base-main>
    </template>
  </gj-modal>
</template>

<script>
  import { modalMixIn, queryMixin } from "@/minxins";
  import { convertToDate } from "@/utils/date.util";
  import { isMeaningful } from "@/utils/common";
  import { keywordRank } from "@/api/ad";

  export default {
    name: "app-ad-log-modal",
    mixins: [ modalMixIn, queryMixin ],
    props: {},
    data() {
      return {
        loading: false,
        tableData: [],
        filter: {
            operatorUserId: null, // 操作人id
            date: null,
            keyword: {
              key: 'groupName',
              value: null
            }
        },
        options: {
          keyword: [
            {id: 'groupName', text: '名称'},
            {id: 'asin', text: 'ASIN'},
          ]
        },
        columns: [
          {id: 'updateTime', header: '操作时间（北京时间）', field: 'updateTime', minWidth: '130px'},
          {id: 'operatingObject', header: '操作对象', field: 'operatingObject', minWidth: '90px'},
          {id: 'opObject', header: '操作名称', field: 'slot:opObject', minWidth: '200px'},
          {id: 'operatingType', header: '操作类型', field: 'option:operatingType', minWidth: '50px',
            options: [ {id: 0, text: '新增'}, {id: 1, text: '修改'}, {id: 2, text: '删除'} ]
          },
          {id: 'content', header: '操作详情', field: 'slot:content', overflowLine: 2, minWidth: '350px'},
          {id: 'updateUser', header: '操作人', field: 'updateUser', minWidth: '100px'},
        ],
      }
    },
    methods: {
      $gjQuery() {
        this.getLog()
      },
      // 获取日志
      async getLog() {
        this.loading = true
        const params = {
          model: {
            startTime: isMeaningful(this.filter.date) ? convertToDate(this.filter.date[0]) : null,
            endTime: isMeaningful(this.filter.date) ? convertToDate(this.filter.date[1]) : null,
            operatorUserId: this.filter.operatorUserId,
            [this.filter.keyword.key]: this.filter.keyword.value
          },
          ...this.queryPagination,
          ...this.querySort
        };
        try {
          let { data } = await keywordRank.keywordRankLogPage(params)
          this.tableData = data.records;
          this.pagination = this.getPagination(data);
        } finally {
          this.loading = false
        }
      }
    },
    created() {}
  }
</script>

<style scoped lang="scss">
.tooltip-h {
  display: flex;
  .tooltip-content {
    flex: 1;
    overflow: hidden;
  }
}
/deep/.vxe-table--border-line{
    border: 1px solid #d8dadd !important;
  }
/deep/.vxe-header--column {
  background: #f6f8fb !important;
}
</style>
